import { down } from 'styled-breakpoints';
import styled from 'styled-components';
import { SelectInput } from '../SelectInput.tsx';
// TODO Sarebbe meglio spostare questa definizione in `@framework/ui`, ma
// avremmo dei problemi di import ciclici.
export const AdvancedSearchSelectInput = styled(SelectInput)`
  min-width: 180px;
  ${down('sm')} {
    min-width: 20px;
  }
  .ant-select-selector {
    border-width: ${props => props.theme.tokenButtonLineWidth}px !important;
    .ant-select-selection-placeholder {
      color: ${props => props.theme.colorText};
      font-weight: 600;
    }
    ${down('sm')} {
      padding: 0 8px !important;
      .ant-select-selection-placeholder {
        padding-inline-end: 12px;
      }
    }
  }
  &.ant-select-open {
    .ant-select-selector {
      .ant-select-selection-placeholder {
        color: ${props => props.theme.colorTextPlaceholder};
        font-weight: normal;
      }
    }
  }
`;
